<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
  <div class="mb-8">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <h1 class="text-3xl font-bold text-gray-900 mb-2">
          {{ "employee.role_staff" | translate }}
        </h1>
        <p class="text-gray-600">
          {{'employeeManagementDesc' | translate}}
        </p>
      </div>

      <div class="flex flex-wrap gap-4">
        <div class="bg-white rounded-lg px-4 py-3 shadow-sm border border-gray-200">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4">
                </path>
              </svg>
            </div>
            <div>
              <p class="text-sm text-gray-600">Total Employee</p>
              <p class="text-lg font-semibold text-gray-900">
                {{ dataSource.data.length }}
              </p>
            </div>
          </div>
        </div>

        <!-- <div class="bg-white rounded-lg px-4 py-3 shadow-sm border border-gray-200">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <div>
              <p class="text-sm text-gray-600">Active employee</p>
              <p class="text-lg font-semibold text-gray-900">
                {{
                (dataSource.data | json).split('"status":"true"').length
                }}
              </p>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 mb-8">
    <div class="flex flex-col lg:flex-row gap-4">
      <div class="flex-1">
        <div class="relative">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
          <input type="text" placeholder="Search projects by name, manager, or stage..."
            class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl leading-5 bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200"
            (input)="applyFilter($event)" />
        </div>
      </div>

      <div class="lg:w-64">
        <select
          class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
          (change)="filterByStatus($event)">
         
          <option value="">{{ "ALL" | translate }}</option>
          <option value="">{{ "ACTIVE" | translate }}</option>
          <option value="">{{ "INACTIVE" | translate }}</option>
         </select>
      </div>
      <div class="flex flex-col sm:flex-row gap-3">
        <button
          class="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-sm"
          [routerLink]="['/home/staff']">
          <mat-icon class="mr-2">add</mat-icon>
          {{ 'add_new_employee' | translate }}
        </button>
        <button [routerLink]="['/home/add-excel-import','Employee']"
          class="inline-flex items-center px-6 py-3 border border-gray-300 text-sm font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-sm">
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path>
          </svg>
          {{ 'IMPORT_EMPLOYEE' | translate }}
        </button>
      </div>

    </div>
  </div>

  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
    <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
      <h2 class="text-lg font-semibold text-gray-900">
        {{'employeeOverview' | translate}}
      </h2>
      <p class="text-sm text-gray-600 mt-1">
        {{'manageEmployees' | translate}}
      </p>
    </div>

    <div class="overflow-x-auto">
      <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="srNo">
          <th mat-header-cell *matHeaderCellDef
            class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            #
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
            {{ i + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="full_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
            class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            {{ "NAME" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center">
              <div class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4">
                  </path>
                </svg>
              </div>
              <div>
                <div class="text-sm font-medium text-gray-900">
                  {{ element.full_name }}
                </div>
                <div class="text-sm text-gray-500">
                  Employee ID: {{ element.id }}
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="current_projects">
          <th mat-header-cell *matHeaderCellDef
            class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            Current project
          </th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4">
            <div class="flex items-start" *ngIf="currentProjectNames(element).length; else unassignedProject">
            
              <div class="min-w-0">
                <div
                  *ngFor="let name of currentProjectNames(element)"
                  class="text-sm font-medium text-gray-900 leading-5"
                >
                  {{ name }}
                </div>
              </div>
            </div>
            <ng-template #unassignedProject>
              <span class="text-sm text-gray-400">Unassigned</span>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
            class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            {{ "ROLE" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center">
              <div class="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center mr-3">
                <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
              </div>
              <div class="text-sm font-medium text-gray-900">
                {{ 'Employee' }}
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="contact_email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
            class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            {{ "EMAIL" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
            <div class="flex items-center">
              <svg class="w-4 h-4 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
              {{ element.contact_email }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="contact_phone">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
            class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            {{ "MOBILE" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center">
              <div class="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center mr-3">
                <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
              </div>
              <div class="text-sm font-medium text-gray-900">
                {{ element?.contact_phone }}
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="isActive">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
            class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            {{ "status" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4 whitespace-nowrap">
            <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium" [ngClass]="{
                'bg-green-100 text-green-800': element.isactive && !element.offboarded_on,
                'bg-red-100 text-red-800': !element.isactive || element.offboarded_on
              }">
              {{ isOffboarded(element) ? "Offboarded" : (element.isactive ? "Active" : "Inactive") }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef
            class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
            {{ "action" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4 whitespace-nowrap text-sm font-medium">
            <div class="flex items-center space-x-2">
              <button [routerLink]="['/home/staff/edit', element.id]"
                class="inline-flex items-center p-2 border border-transparent rounded-lg text-blue-600 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200"
                title="Edit employee">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                  </path>
                </svg>
              </button>
              <!-- Offboard button - shown only for active employees -->
              <button *ngIf="!isOffboarded(element)" (click)="offboardStaff(element.id, element.full_name)"
                class="inline-flex items-center p-2 border border-transparent rounded-lg text-orange-600 hover:bg-orange-50 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors duration-200"
                title="Offboard employee">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636">
                  </path>
                </svg>
              </button>
              <!-- Reinstate button - shown only for offboarded employees -->
              <button *ngIf="isOffboarded(element)" (click)="reinstateStaff(element.id, element.full_name)"
                class="inline-flex items-center p-2 border border-transparent rounded-lg text-green-600 hover:bg-green-50 focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors duration-200"
                title="Reinstate employee">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z">
                  </path>
                </svg>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-50"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"
          class="hover:bg-gray-50 transition-colors duration-150"></tr>
      </table>
    </div>

    <div *ngIf="dataSource.data.length === 0" class="text-center py-12">
      <div class="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4">
          </path>
        </svg>
      </div>
      <h3 class="text-lg font-medium text-gray-900 mb-2">
        {{'noEmployeeFound' | translate}}
      </h3>
      <p class="text-gray-500 mb-6">
        {{'startByCreatingEmployee' | translate}}

      </p>
      <button routerLink="/home/staff"
        class="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
        </svg>
        {{'createFirstEmployee' | translate}}

      </button>
    </div>

    <div class="px-6 py-4 border-t border-gray-200 bg-gray-50">
      <mat-paginator [length]="dataSource.data.length" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]"
        showFirstLastButtons class="bg-transparent">
      </mat-paginator>
    </div>
  </div>
</div>